<template>
	<div class="customers">
		<ul class="customers__list">
			<li
				v-for="(customer, index) in items"
				class="customers__item"
				:key="customer.id + index"
				:style="{
					zIndex: items.length + 100 - index
				}"
			>
				<CustomerCard :customer="customer" />
			</li>
		</ul>
	</div>
</template>

<script>
import CustomerCard from './customer-card';

export default {
	name: 'CustomersList',
	components: {
		CustomerCard
	},
	props: {
		items: {
			type: Array,
			default: () => []
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Customer Results List
    * Can use SCSS variables = TRUE
*/

.customers {
	&__item {
		position: relative;
		margin-bottom: $gutter-lg;
	}
}
</style>
